import React, { useState } from 'react'
import { DataContext } from '../../helper/HelperOne';
import NavBar from '../nav_bar/Navbar';
import LeadRoleCreate from './LeadRoleCreate';

function LeadRole() {
    const [searchUi, setSearchUi] = useState(true);
    const [searchData, setSearchData] = useState(null);

    return (
        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<LeadRoleCreate />}
                menuId={6}
            />
        </DataContext.Provider>
    );
}

export default LeadRole